import { useEffect, useState } from "react";

const initialState = { namingPrice: null };

function useContractValues({ readContracts, keys }) {
  const [values, setValues] = useState(initialState);
  const [newValues, getNewValues] = useState(0);
  console.log("about to get useContractValues");

  useEffect(() => {
    if (readContracts) {
      let promiseArr = [];
      for (let key of keys) {
        if (key[2]) {
          promiseArr.push(readContracts[key[0]][key[1]](...key[2]));
        } else {
          promiseArr.push(readContracts[key[0]][key[1]]());
        }
      }
      Promise.all(promiseArr)
        .then((results) => {
          let resultsObject = {};
          for (let i = 0; i < results.length; i++) {
            resultsObject[keys[i][1]] = results[i];
          }
          console.log(resultsObject);
          setValues(resultsObject);
        })
        .catch((errors) => {
          console.log(errors);
          debugger;
        });
    }
  }, [readContracts, newValues, keys]);
  return { values, getNewValues };
}

export default useContractValues;
